import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { PWAProvider } from "./pwa/PWAProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import OfflineBanner from "./pwa/OfflineBanner";
import InstallPrompt from "./pwa/InstallPrompt";
import UpdatePrompt from "./pwa/UpdatePrompt";

// Pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import Unauthorized from "./pages/Unauthorized";
import Dashboard from "./pages/Dashboard";
import Devices from "./pages/Devices";
import Monitoring from "./pages/Monitoring";
import Topology from "./pages/Topology";
import Alerts from "./pages/Alerts";
import Anomalies from "./pages/Anomalies";
import SLA from "./pages/SLA";
import Reports from "./pages/Reports";
import ScheduledReports from "./pages/ScheduledReports";
import UserManagement from "./pages/UserManagement";
import AuditLogs from "./pages/AuditLogs";
import PWASettings from "./pages/PWASettings";

const protectedRoutes = [
  { path: "/dashboard", component: Dashboard, roles: ["NETWORK_ADMINISTRATOR", "ICT_SUPPORT_STAFF"] },
  { path: "/devices", component: Devices, roles: ["NETWORK_ADMINISTRATOR", "ICT_SUPPORT_STAFF"] },
  { path: "/monitoring", component: Monitoring, roles: ["NETWORK_ADMINISTRATOR", "ICT_SUPPORT_STAFF"] },
  { path: "/topology", component: Topology, roles: ["NETWORK_ADMINISTRATOR", "ICT_SUPPORT_STAFF"] },
  { path: "/alerts", component: Alerts, roles: ["NETWORK_ADMINISTRATOR", "ICT_SUPPORT_STAFF"] },
  { path: "/anomalies", component: Anomalies, roles: ["NETWORK_ADMINISTRATOR", "ICT_SUPPORT_STAFF"] },
  { path: "/sla", component: SLA, roles: ["NETWORK_ADMINISTRATOR", "ICT_SUPPORT_STAFF"] },
  { path: "/reports", component: Reports, roles: ["NETWORK_ADMINISTRATOR", "ICT_SUPPORT_STAFF"] },
  { path: "/scheduled-reports", component: ScheduledReports, roles: ["NETWORK_ADMINISTRATOR", "ICT_SUPPORT_STAFF"] },
  { path: "/pwa", component: PWASettings, roles: ["NETWORK_ADMINISTRATOR", "ICT_SUPPORT_STAFF"] },
  { path: "/users", component: UserManagement, roles: ["NETWORK_ADMINISTRATOR"] },
  { path: "/audit", component: AuditLogs, roles: ["NETWORK_ADMINISTRATOR"] },
];

function App() {
  return (
    <PWAProvider>
      <AuthProvider>
        <BrowserRouter>
          {/* PWA Global Components */}
          <OfflineBanner />
          <InstallPrompt />
          <UpdatePrompt />

          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/unauthorized" element={<Unauthorized />} />

            {protectedRoutes.map(({ path, component: Component, roles }) => (
              <Route
                key={path}
                path={path}
                element={
                  <ProtectedRoute roles={roles}>
                    <Component />
                  </ProtectedRoute>
                }
              />
            ))}
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </PWAProvider>
  );
}

export default App;